module.exports = __webpack_public_path__ + "img/partners-hero.d69c9e74.svg";